import {
  SupportApi,

  useAPIQuery
  ,
} from "melco-shared-logic";

export const useAccountSupportStatus = (userId?: string) => {

  return useAPIQuery(
    SupportApi,
    ["accountSupportStatus"],
    async (api) => {
      //const api = new SupportApi(baseApiConfig({ token, impersonationForId: userId }));

      //api.defaultsGetReferralList
      const response = await api.supportStatus();

      return response;
    },
    {
      queryOptions: {
        keepPreviousData: true,

      },
      apiConfigOptions: {
        impersonationForId: userId
      }
    }
  );
};
